<template>
  <button class="sidebar-minimizer" type="button" @click="sidebarMinimize();brandMinimize()"></button>
</template>
<script>
/* eslint-disable */
export default {
  name: 'sidebar-minimizer',
  computed: {
    minimizeSidebar () {
      return this.$store.getters.minimizeSidebar
    },
  },
  methods: {
    sidebarMinimize () {
      if (this.minimizeSidebar) {
        this.$store.commit('RESTORE_SIDEBAR');
      } else {
        this.$store.commit('MINIMIZE_SIDEBAR');
      }
      document.body.classList.toggle('sidebar-minimized')
    },
    brandMinimize () {
      document.body.classList.toggle('brand-minimized')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/SidebarMinimizer.vue